import { MENU } from '../data/pricing';
import { eyebrow, h1 } from '../lib/styles';

const Pricing = () => (
  <div style={{ padding: '5vw', maxWidth: 1000, margin: '0 auto' }}>
    <div style={{ textAlign: 'center', marginBottom: '4vw' }}>
      <span style={eyebrow}>Precios</span>
      <h1 style={h1}>Menú de servicios</h1>
      <p style={{ fontSize: 15.5, lineHeight: 1.7, color: 'var(--ink-600)', maxWidth: '48ch', margin: '0 auto' }}>
        Precios en pesos mexicanos. El diseño de uñas y los extras se cotizan al momento.
      </p>
    </div>
    <div
      style={{
        background: 'var(--caution-soft)',
        border: '1px solid rgba(169,118,42,.25)',
        borderRadius: 'var(--radius-md)',
        padding: '14px 18px',
        marginBottom: '4vw',
        fontSize: 13,
        lineHeight: 1.6,
        color: 'var(--caution)',
      }}
    >
      Placeholder: estos precios son de referencia. Sustituir por el menú oficial de Zenya antes de publicar.
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw' }}>
      {MENU.map((g) => (
        <div key={g.nombre}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, marginBottom: 22 }}>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 300,
                fontSize: 'clamp(26px, 3.6vw, 38px)',
                color: 'var(--ink-900)',
                margin: 0,
                whiteSpace: 'nowrap',
              }}
            >
              {g.nombre}
            </h2>
            <span style={{ flex: 1, height: 1, background: 'var(--ink-200)' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {g.items.map((i) => (
              <div
                key={i.nombre}
                style={{
                  display: 'flex',
                  gap: 18,
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                  padding: '14px 0',
                  borderBottom: '1px solid var(--ink-100)',
                }}
              >
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 16, color: 'var(--ink-800)', letterSpacing: '.01em' }}>{i.nombre}</div>
                  <div style={{ fontSize: 13.5, color: 'var(--ink-500)', marginTop: 3 }}>{i.nota}</div>
                </div>
                <span
                  style={{
                    fontSize: 12,
                    letterSpacing: '.1em',
                    textTransform: 'uppercase',
                    color: 'var(--ink-500)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {i.duracion}
                </span>
                <span
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: 24,
                    color: 'var(--rose-700)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {i.precio}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Pricing;
